module.exports = __webpack_public_path__ + "img/review-no-preview.aa4d2dfd.jpg";